import { Button, Col, Container, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import DynamicForm from './newplusbox';
function Formsubmit() {
    return (
       <>
       <div className='d-flex justify-content-center align-items-center'>
       <Container className='bg-primary-subtle border border-light-subtle rounded-2 m-3 p-3'>
            <Row>
                <Col md={6} className='py-2 h-100'>
                <h2>Enroll form</h2>
                    <Form>
                        
                            <Form.Group className="mb-3" as={Col} controlId="formGridEmail">
                                <Form.Label>Email</Form.Label>
                                <Form.Control type="email" placeholder="Enter email" />
                            </Form.Group>

                            <Form.Group className="mb-3" as={Col} controlId="formGridPassword">
                                <Form.Label>Password</Form.Label>
                                <Form.Control type="password" placeholder="Password" />
                            </Form.Group>
                        

                        <Form.Group className="mb-3" controlId="formGridAddress1">
                            <Form.Label>Address</Form.Label>
                            <Form.Control placeholder="1234 Main St" />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formGridAddress2">
                            <Form.Label>Address 2</Form.Label>
                            <Form.Control placeholder="Apartment, studio, or floor" />
                        </Form.Group>

                        

                        <Form.Group className="mb-3" id="formGridCheckbox">
                            <Form.Check type="checkbox" label="Check me out" />
                        </Form.Group>
                        <div className='d-flex justify-content-center'>
                        <Button  variant="primary" type="submit">
                            Submit
                        </Button>

                        </div>

                        
                    </Form>
                </Col>
                <Col>
                <DynamicForm/>
                </Col>
            </Row>
        </Container>
       </div>

       </>
    );
}

export default Formsubmit;
